import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosConfig from "../../api/axiosConfig";

const AdminSettingsPage = () => {
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  }); 
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // Burada localStorage’dan adminId veya token üzerinden gelen id'yi alıyoruz.
  const adminId = localStorage.getItem("adminId");
  const token = localStorage.getItem("token");

  // Sayfa ilk yüklendiğinde admin bilgilerini çek
  useEffect(() => {
    if (!token) {
      // Token yoksa giriş sayfasına yönlendir
      navigate("/admin/login");
      return;
    }

    const fetchAdminData = async () => {
      try {
        const response = await axiosConfig.get(`/admin/${adminId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }); 
        // Gelen veriyi state'e koy
        setAdminData({
          name: response.data.name || "",
          email: response.data.email || "",
          password: "",
          confirmPassword: "",
        });
      } catch (error) {
        console.error("Admin bilgisi alınırken hata:", error);
        setErrorMessage("Admin bilgisi alınırken hata oluştu.");
      }
    };

    fetchAdminData();
  }, [adminId, token, navigate]);

  // Form submit (güncelleme)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    // Şifre doğrulaması
    if (
      adminData.password &&
      adminData.password !== adminData.confirmPassword
    ) {
      setErrorMessage("Şifreler eşleşmiyor!");
      return;
    }

    try {
      // PUT /admin/:id
      const response = await axiosConfig.put(
        `/admin/${adminId}`,
        {
          name: adminData.name,
          email: adminData.email,
          password: adminData.password ? adminData.password : undefined,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccessMessage(response.data.message || "Başarıyla güncellendi!");

      // Şifre alanlarını temizliyoruz
      setAdminData((prev) => ({
        ...prev,
        password: "",
        confirmPassword: "",
      }));
    } catch (error) {
      console.error("Admin güncellenirken hata:", error);
      if (error.response) {
        setErrorMessage(error.response.data.message || "Güncelleme hata aldı!");
      } else {
        setErrorMessage("Sunucu bağlantı hatası!");
      }
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* (Opsiyonel) Sidebar veya Layout yapınız varsa ekleyebilirsiniz */}
      {/* <Sidebar /> */}

      <div className="flex-1 flex flex-col p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Admin Ayarları</h1>

        <div className="bg-white p-4 rounded shadow max-w-xl">
          {errorMessage && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
              {errorMessage}
            </div>
          )}
          {successMessage && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
              {successMessage}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                htmlFor="name"
                className="block text-gray-700 font-semibold mb-1"
              >
                İsim
              </label>
              <input
                id="name"
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 
                           focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={adminData.name}
                onChange={(e) =>
                  setAdminData({ ...adminData, name: e.target.value })
                }
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-gray-700 font-semibold mb-1"
              >
                Email
              </label>
              <input
                id="email"
                type="email"
                className="w-full border border-gray-300 rounded px-3 py-2 
                           focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={adminData.email}
                onChange={(e) =>
                  setAdminData({ ...adminData, email: e.target.value })
                }
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="password"
                className="block text-gray-700 font-semibold mb-1"
              >
                Yeni Şifre (Değiştirmek istemiyorsanız boş bırakın)
              </label>
              <input
                id="password"
                type="password"
                className="w-full border border-gray-300 rounded px-3 py-2 
                           focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={adminData.password}
                onChange={(e) =>
                  setAdminData({ ...adminData, password: e.target.value })
                }
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="confirmPassword"
                className="block text-gray-700 font-semibold mb-1"
              >
                Yeni Şifre (Tekrar)
              </label>
              <input
                id="confirmPassword"
                type="password"
                className="w-full border border-gray-300 rounded px-3 py-2 
                           focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={adminData.confirmPassword}
                onChange={(e) =>
                  setAdminData({ ...adminData, confirmPassword: e.target.value })
                }
              />
            </div>
            <button
              type="submit"
              className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
            >
              Kaydet
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminSettingsPage;
